import { Phone, Mail, MapPin } from "lucide-react";

const LOGO = "/brand/themboys-logo.jpg";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-[#EBE8DD] mt-24" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="bg-black p-3 inline-block max-w-[220px]">
            <img
              src={LOGO}
              alt="Them Boys Moving & Storage"
              className="w-full object-contain"
            />
          </div>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-[#EBE8DD]/70">
            A Kentucky-grown moving &amp; storage crew that shows up on time, treats your stuff
            like it's ours, and gets you settled — across KY, IN, OH and WV.
          </p>
          <div className="mt-8 font-mono-label text-[10px] text-[#EBE8DD]/50">
            Your Local Moving Pros · Family-Owned
          </div>
        </div>

        <div>
          <div className="overline text-[#EBE8DD]/60">Reach Us</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <Phone className="w-3.5 h-3.5 text-[#5BB239]" />
              <a href="tel:+15025077904" className="hover:text-[#5BB239] transition-colors">
                (502) 507-7904
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-3.5 h-3.5 text-[#5BB239]" /> themboyshauling@gmail.com
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-3.5 h-3.5 text-[#5BB239] mt-0.5" />
              <span>Louisville, KY<br />Serving the region</span>
            </li>
          </ul>
        </div>

        <div>
          <div className="overline text-[#EBE8DD]/60">Hours</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li className="flex justify-between"><span>Mon–Fri</span><span>7a — 8p</span></li>
            <li className="flex justify-between"><span>Saturday</span><span>8a — 6p</span></li>
            <li className="flex justify-between"><span>Sunday</span><span>By appt.</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#EBE8DD]/10">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 py-5 flex flex-col md:flex-row justify-between text-xs text-[#EBE8DD]/50">
          <span>© {new Date().getFullYear()} Them Boys Moving &amp; Storage. All rights reserved.</span>
          <span className="font-mono-label">SERVING KY · IN · OH · WV</span>
        </div>
      </div>
    </footer>
  );
}
